export default __webpack_public_path__ + "b47c6c1c5a003532331197d6a51c2647.png";